export const versioned = [
    {
        minmax: [0, undefined],
        types: {
        // nothing, limited runtime
        }
    }
];
